import { render, staticRenderFns } from "./AnagraficaCompany.vue?vue&type=template&id=c331d61e&"
import script from "./AnagraficaCompany.vue?vue&type=script&lang=js&"
export * from "./AnagraficaCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports